import React, { memo, useMemo } from 'react'
import { Link } from 'react-router-dom'

const Footer = memo(function Footer() {
    const currentYear = useMemo(() => new Date().getFullYear(), []);

    return (
        <footer className="p-l-r">
            <div className="container-fluid">
                <ul className="footer-menu">
                    <li><Link to="/">Home</Link></li>
                    <li>
                        <Link to='/about/our-company'>Our Company</Link>
                    </li>
                    <li>
                        <Link to='/about/our-experts'>Our Experts</Link>
                    </li>
                    <li>
                        <Link to='/services/overview'>Service Overview</Link>
                    </li>
                    <li>
                        <Link to='/services/individuals'>Individuals</Link>
                    </li>
                    <li>
                        <Link to='/services/companies'>Companies</Link>
                    </li>
                    <li><Link to="/clientele">Clientele</Link></li>
                    <li><Link to="/plans">Plans</Link></li>
                    <li><a href="/#faq">FAQ's</a></li>
                    <li><Link to="/contact-us">Contact Us</Link></li>
                    <li><Link to="/blog">Blogs</Link></li>
                    <li><Link to="/terms-and-conditions">Terms</Link></li>
                    <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                </ul>
                <div className="download-box">
                    <a href="https://apps.apple.com/in/app/the-beyond-lifestyle/id6478144849" target="_blank" rel="noopener noreferrer">
                        <img src={require('../assets/images/apple.png')} alt="iOS App Download" loading="lazy" />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.tblstyle" target="_blank" rel="noopener noreferrer">
                        <img src={require('../assets/images/android.png')} alt="Android App Download" loading="lazy" />
                    </a>
                </div>
                <div className="social-media">
                    <ul>
                        <li><a href="https://www.facebook.com/TheBeyondLifestyleApp" target="_blank" rel="noopener noreferrer"><i
                            className="fa-brands fa-facebook-f"></i></a></li>
                        <li><a href="https://twitter.com/LifestyleApp24" target="_blank" rel="noopener noreferrer"><i
                            className="fa-brands fa-x-twitter"></i></a></li>
                        <li><a href="https://www.instagram.com/the_beyond_lifestyle/" target="_blank" rel="noopener noreferrer"><i
                            className="fa-brands fa-instagram"></i></a></li>
                        <li><a href="https://www.youtube.com/@TheBeyondLifestyle" target="_blank" rel="noopener noreferrer"><i
                            className="fa-brands fa-youtube"></i></a></li>
                        <li><a href="https://www.linkedin.com/company/the-beyond-lifestyle/" target="_blank" rel="noopener noreferrer"><i
                            className="fa-brands fa-linkedin-in"></i></a></li>
                    </ul>
                </div>
                <div className="copy-right">
                    <p>Copyright © <span id="date">{currentYear}</span> The Beyondlifestyle. All rights reserved.</p>
                </div>
                <div className='disclaimer-section'>
                    <p><strong>Disclaimer:</strong> The Beyond Lifestyle is not designed to handle medical, psychological, or psychiatric emergencies. This platform does not provide crisis support, medical support especially in situations involving suicidal thoughts, self-harm, or symptoms of severe mental health conditions such as schizophrenia or other psychotic disorders. If you or someone you know is in crisis, it is crucial to seek immediate help from a medical professional. Please visit the nearest hospital or emergency facility to speak directly with a psychiatrist, therapist, counsellor, or social worker.</p>
                    <p>We also encourage you to reach out to a trusted family member or friend who can support you during this time. For urgent mental health support, please contact a suicide prevention helpline available in your country. Your safety and well-being are of utmost importance. Please don't hesitate to seek the immediate care you need.</p>
                </div>
            </div>
        </footer>
    )
});

Footer.displayName = 'Footer';
export default Footer;
